import { Box, Flex } from "@chakra-ui/react";
import { SecureRoute } from "@okta/okta-react";
import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import FormLoadingOverlay from "../components/common-quote/FormLoadingOverlay";
import useUser from "../hooks/useUser";
import { UserRole } from "../lib/models/enums";
export interface GuardedRouteProps {
  component: React.ComponentType<any>;
  fallback: string;
  exact: any;
  path: any;
  key: any;
  rolesNeededtoActivateRoute: Array<UserRole>;
}
function GuardedRoute(props: GuardedRouteProps) {
  const {
    component: Component,
    exact,
    path,
    key,
    fallback,
    rolesNeededtoActivateRoute,
  } = props;

  const user = useUser();

  const { role } = user;

  const [status, setStatus] = useState<"loading" | "canActivate" | "redirect">(
    "loading"
  );

  React.useEffect(() => {
    if (!role) {
      return;
    }

    if (rolesNeededtoActivateRoute.length < 1) {
      setStatus("canActivate");
      return;
    }

    if (rolesNeededtoActivateRoute.includes(role)) {
      setStatus("canActivate");
      return;
    }
  }, [role, rolesNeededtoActivateRoute, status, setStatus]);

  if (status === "loading") {
    return (
      <Flex>
        <Box
          position="relative"
          width="full"
          minH={"813px"}
          padding={{ base: 1, md: 4 }}
          marginTop={8}
        >
          <FormLoadingOverlay label="Loading..." />
        </Box>
      </Flex>
    );
  }

  return status === "canActivate" ? (
    <SecureRoute
      exact={exact}
      path={path}
      key={key}
      render={(props) => <Component {...props} />}
    />
  ) : (
    <Redirect to={fallback} />
  );
}
export default GuardedRoute;
